import { Money } from "models/money";
import { Unit } from "models/unit";

export function getExcelData(data) {
  let rows = [];
  data.forEach((elem, index) => {
    var _known = {
      Nro: index + 1,
      Producto: elem.product.name,
      Codigo: elem.product.code,
      Presentacion: elem.product.presentation,
      Unidad: elem.product.unitContent,
      PVP: Money(elem.pvp),
      Cantidad: Unit(elem.quantity),
    };
    rows.push(_known);
  });
  return rows;
}
